import {
  toReactNodes
} from "./chunk-3NZOR3KT.js";
import {
  StyledLabel,
  getPropDefaults
} from "./chunk-3AS7NXWQ.js";
import {
  __spreadProps,
  __spreadValues
} from "./chunk-CWMXXUWU.js";

// src/components/typography/Label.tsx
import { jsx } from "@emotion/react/jsx-runtime";
function Label(props) {
  const propsWithDefaults = getPropDefaults(props);
  let reactNodes = props.children || null;
  if (props.content) {
    reactNodes = toReactNodes(props.content);
  }
  return /* @__PURE__ */ jsx(StyledLabel, __spreadProps(__spreadValues({}, propsWithDefaults), { children: reactNodes }));
}

export {
  Label
};
